import { EmbeddedUser } from './types';

export function getUserTitle(user: EmbeddedUser): string {
  return user.first_name ? `${user.first_name} ${user.last_name}` : user.email;
}
